<template>
    <div>
      <h2>미션 업무</h2>
      <p>
        <span class="bg-yellow-13">숙제 관리의 중요성</span>은 <span class="bg-light-green-13">학습자의 학습 과정을 지속적으로 추적하고 지원하기 위한 핵심 요소</span>입니다. <br/>
        다만, 숙제는 세부항목별로 체크하는 기능이 없습니다.<br/>
        따라서, <span class="bg-light-green-13">미션으로 구체적인 활동 내역을 체크하는 기능을 추가</span>합니다. <br/>
        이는 학생들에게 더욱 세분화된 학습 목표를 제공할 수 있게 하며, 학습자 스스로 자신의 진행 상황을 관리하고 평가할 수 있도록 기능을 극대화 시킵니다. <br/>
        예를 들어, 각 미션은 특정 주제에 대한 독서, 문제 풀이, 프로젝트 완성 등과 같은 다양한 활동을 포함할 수 있으며, 이를 통해 학생들은 자신의 학습 경로를 좀 더 명확하고 체계적으로 이해하고 개선할 수 있습니다.<br/>
      </p>
      <p>
        또한 미션은 숙제 뿐아니라, 수업 중에 일어나는 활동을 구체적으로 제시하여, 수업 활동의 상황을 관리하고 평가할 수 있습니다. <br/>
        즉, 수업활동과 숙제를 모두 미션으로 대체할 수 있습니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="mission_process">
            <div class="ft-b">1)    미션프로세스</div>
        
            <div class="p-relative section_2">
                미션 프로세스는 다음과 같습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_mission_process.jpg" /></div>
            </div>
            
        </div>

        <p></p>
        <div class="p-relative section_0" id="add_mission">
            <div class="ft-b">2)    미션 생성</div>
        
            <div class="p-relative section_1">
                선생님이 미션을 생성하는 페이지는 다음의 두군데입니다.
            </div>
            <div class="p-relative section_1">
                a.  수업관리 > 오늘수업  b.  업무프로세스 > 수업미션관리
            </div>
            <p></p>
            <div class="p-relative section_1">
                - a. 수업관리 > 오늘수업화면에서는 수업에 설정되어 있는 미션을 볼 수 있습니다.
            </div>
            <div class="p-relative section_2">
                수업미션을 생성하고, 학생 개별로 미션을 추가할 수 있습니다. 또한 지난 미션에 대해 피드백을 통하여 미션을 다시 수행하도록 할 수 있습니다.
            </div>
            <p></p>
            <div class="p-relative section_1">
                - 다음은 
            </div>
            <div class="p-relative section_2">
                미션 생성화면입니다.
                <div class="p-absolute" style="top:-30px; left:200px;">
                    <img src="@/assets/aca/manual/job/job_mission_add.jpg" />
                </div>
            </div>
            <div style="height:220px;"></div>

            <div class="p-relative section_1">
                - b. 업무프로세스 > 수업미션관리화면에서 미션을 생성할 수 있습니다.<br/>
                수업을 선택 후 "목록"버튼(이는 미션목록을 의미함)을 클릭합니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_mission_add_modal_2.jpg" /></div>
            </div>

            <p></p>
            <div class="p-relative section_1">
                - 미션생성 버튼을 클릭하면 다음과 같은 화면이 나타납니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_mission_add_modal.jpg" /></div>
            </div>


            <p></p>
            <div class="p-relative section_1" style="width:300px; height:380px;">
                - 미션은 구체적일수록 좋습니다.<br/>
                예를들어 다음과 같은 형태로 미션을 부여할 수 있습니다.

                <div class="p-absolute" style="top:0px; left:320px;">
                    <img src="@/assets/aca/manual/job/job_mission_item_add.jpg" />
                </div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="mission_app">
            <div class="ft-b">3)    학생앱에서 미션 체크</div>
        
            <div class="p-relative section_1">
                - 미션이 생성되면 학생은 학생앱에서 미션을 제출할 수 있습니다.
            </div>
            <div class="p-relative section_1">
                - 미션은 여러 개의 항목으로 이루어져 있으며, 각 항목을 체크함으로써 미션의 전체 진행정도를 파악할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_mission_app.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="mission_feedback">
            <div class="ft-b">4)    선생님의 미션 검토</div>
        
            <div class="p-relative section_1">
                - 선생님은 학생이 제출한 미션에 대하여 검토하고 피드백을 줄 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_mission_feedback.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="mission_app_feedback">
            <div class="ft-b">5)    학생앱에서 재검토된 미션 체크</div>
        
            <div class="p-relative section_1" style="width:300px; height:340px;">
                - 선생님이 제출한 미션에 대해 재검토를 지정하면, 재검토된 미션은 학생이 다시 제출하여야 합니다.

                <div class="p-absolute" style="top:-100px; left:160px;">
                    <img src="@/assets/aca/manual/job/job_mission_app_feedback.png" />
                </div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="mission_list">
            <div class="ft-b">6)    수업 미션 관리</div>
        
            <div class="p-relative section_1">
                - 미션은 담임 또는 당당강사가 수업화면에서 관리할 수 있습니다.<br/>
                  이 경우는 자신의 반에 대해서만 관리가 이루어집니다.<br/>
            </div>
            <div class="p-relative section_2">
                학원 전체의 미션을 통합관리하기 위해서 업무프로세스 > 수업미션관리 메뉴에서 관리할 수 있습니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_mission_list.jpg" /></div>
            </div>


            <div class="p-relative section_1">
                - 이 화면에서 관리할 수 있는 기능은 다음과 같습니다.<br/>
                a.  미션생성 및 수정<br/>
                b.  제출된 미션 목록<br/>
                c.  피드백 설정<br/>
            </div>

            
        </div>
        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '미션프로세스', link: '#mission_process' },
                { label: '미션 생성', link: '#add_mission' },
                { label: '학생앱에서 미션 체크', link: '#mission_app' },
                { label: '선생님의 미션 검토', link: '#mission_feedback' },
                { label: '학생앱에서 재검토된 미션 체크', link: '#mission_app_feedback' },
                { label: '수업 미션 관리', link: '#mission_list' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


